/** Тонкая обёртка-shim над apiRequest для совместимости с импортами из proba-кода.
 *
 *  Сигнатура api.get/post/patch/del соответствует proba lib/api.ts, под капотом
 *  всё идёт через наш apiRequest (DRF Token из sessionStorage, без CSRF/cookie).
 *  Ошибки приводятся к ApiError-форме `{ detail, status, body }`; status=0 для
 *  сетевых/обёрточных ошибок (реальный HTTP-код приходит из `ApiRequestError`).
 *  `body` — разобранное тело ответа, нужно для раскрытого тоста (поля валидации)
 *  и для transition-эндпоинтов (дополнительные поля `field` / `code` 409/422).
 */
import { apiRequest, ApiRequestError } from '~/lib/apiRequest'

export interface ApiError {
  detail: string
  status: number
  /** Разобранное тело ответа сервера (для детализации ошибки в UI). */
  body?: unknown
}

async function wrap<T>(promise: Promise<T>): Promise<T> {
  try {
    return await promise
  } catch (e) {
    if (e instanceof ApiRequestError) {
      const err: ApiError = { detail: e.message, status: e.status, body: e.body }
      throw err
    }
    const detail = e instanceof Error ? e.message : String(e)
    const err: ApiError = { detail, status: 0 }
    throw err
  }
}

export const api = {
  get: <T>(path: string) => wrap(apiRequest<T>('GET', path)),
  post: <T>(path: string, body?: unknown) => wrap(apiRequest<T>('POST', path, body ?? {})),
  patch: <T>(path: string, body?: unknown) => wrap(apiRequest<T>('PATCH', path, body ?? {})),
  del: <T>(path: string) => wrap(apiRequest<T>('DELETE', path)),
}
